import LyricsGame from '../components/LyricsGame';
import './lyricsPractice.css';

const LyricsPractice60 = () => (
    <div className="app lyrics-game-page">
        <main aria-label="60초 가사·응원법 연습 게임"><LyricsGame /></main>
    </div>
);

export default LyricsPractice60;
